import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { InvoiceReportAsPaidFormContainerProps } from "models/propTypes/invoicePropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import InvoiceReportAsPaidForm from "./reportAsPaidForm";
import { useInvoiceService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const InvoiceReportAsPaidFormContainer: ForwardRefRenderFunction<FormHandles, InvoiceReportAsPaidFormContainerProps> = (
  props,
  ref
) => {
  const invoiceService = useInvoiceService();
  const initialValues = React.useMemo(
    () => ({
      paymentDate: props.paymentDate ?? new Date(),
    }),
    []
  );

  const handleSubmit = React.useCallback(
    (values: InvoiceFormTypes.ReportAsPaid) => {
      return invoiceService.reportAsPaid(props.invoiceId, {
        paymentDate: values.paymentDate,
      });
    },
    [props.invoiceId]
  );

  return (
    <InvoiceReportAsPaidForm
      ref={ref}
      {...props}
      validationSchema={Yup.object<InvoiceFormTypes.ReportAsPaid>({
        paymentDate: Yup.date()
          .required(TranslationKeys.Validations.Required)
          .typeError(TranslationKeys.Validations.InvalidDate),
      })}
      defaultValues={initialValues}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(InvoiceReportAsPaidFormContainer);
